module.exports = __webpack_public_path__ + "img/vue.js-logo.82b9c7a5.png";